import React from 'react';
import { Trans } from 'react-i18next';
import s from './Loader.styles';

const Loader = ({ withText = true, text = 'LOADING', ...rest }) => (
  <s.Loader withText={withText} {...rest}>
    <s.Spinner name="tail-spin" />
    {withText && <Trans>{text}</Trans>}
  </s.Loader>
);

export default React.memo(Loader);
